import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';

// InfoBlocks
import {
  InfoSection,
  FeatureList,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';

const Banner = () => {

  const features = [
    {
      title: '시각적 경고 효과 극대화',
      bullets: [
      {
        label: (
          <>공사·사고·통제 구간 등에 긴급 안내 정보 전달</>
        ),
      },
      {
        label: (
          <>고가시성 배너 사용으로 운전자의 인지율 향상</>
        ),
      },
      {
        label: (
          <>야간 및 악천후 환경에서도 확실한 경고 효과 제공</>
        ),
      },
      ]
    },
    {
      title: '간편하고 빠른 설치·철거',
      bullets: [
      {
        label: (
          <>배너를 쉽게 펼치고 감을 수 있는 구조로 작업 시간 단축</>
        ),
      },
      {
        label: (
          <>별도의 복잡한 장비 없이 누구나 손쉽게 운영 가능</>
        ),
      },
      {
        label: (
          <>이동성과 설치 편의성을 극대화한 설계</>
        ),
      },
      ]
    },
    {
      title: '유지관리 편의성 강화',
      bullets: [
      {
        label: (
          <>보관이 간편한 컴팩트한 구조</>
        ),
      },
      {
        label: (
          <>장시간 외부 환경에 견디는 내구성 높은 소재 적용</>
        ),
      },
      {
        label: (
          <>사용 후 빠르게 정리 가능하여 재활용도 용이</>
        ),
      },
      ]
    },
    {
      title: '다양한 도로 환경 대응',
      bullets: [
      {
        label: (
          <>고속도로·지방도·시내도로 등 다양한 설치 조건에 적합</>
        ),
      },
      {
        label: (
          <>교통량, 현장 특성에 따라 배너 크기·내용을 유연하게 적용 가능</>
        ),
      },
      {
        label: (
          <>공사현장, 고장차량 통제, 임시 교통안내 등 다목적 활용 가능</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`배너걸이장치`}
        subtitle={`시각적인 경고를 제공하여 \n도로안전 관리의 효율성을 높입니다`}
        backgroundImage="/images/products/facilities/banner5.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '배너걸이장치' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`안전운전을 유도를 위한 필수 교통 안전 안내 장치`}
        title={`배너걸이장치`}
        description={
          <>
            각종 자동차도로 노변에 설치되어 <strong>도로공사, 사고, 기상 악화 등 긴급 상황 발생 시 운전자에게 시각적인 경고를 제공</strong>하고, {' '}
            이를 통해 안전운전을 유도하는 필수 교통 안전 안내 장치입니다.
            <br />
            <br />
            배너를 <strong>간편하게 펼치고 감을 수 있는 구조</strong>로 설계되어 설치·철거·보관이 용이해, {' '}
            현장에서 신속한 교통 통제와 안전 관리가 필요한 상황에서 효율성을 높입니다.
          </>
        }
        images={[
          '/images/products/facilities/banner2.jpg',
          '/images/products/facilities/banner3.jpg',

        ]}
      />

      <SectionDivider />


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="facilities"
        currentPath="/products/facilities/banner"
        listPath="/products/facilities"
      />


      <CTASection />
    </>
  );
};

export default Banner;
